
<template>
  <div>
    <new-negotiation/>
  </div>
</template>

<script>

export default {
  name: 'RequestNegotiation',
  components: {
    NewNegotiation: () => import ('@/components/negotiations/NewNegotiation.vue')
  },
}
</script>

<style scoped>

</style>